import * as ngCore from '@angular/core'
import * as ngMatDatepicker from '@angular/material/datepicker'

import * as models from '../../models'
import * as header from '../../multiple/header' // FIXME: if this imports from multiple, it causes circular dependency in tests
import { Store } from '../../store'

import * as customRanges from './custom-ranges'
import * as form from './form'
/**
 * This component is injected via
 * {@link ngMatDatepicker.MatDateRangePicker.calendarHeaderComponent} into the
 * {@link  ngMatDatepicker.MatDateRangePicker} overlay. Use it to render custom
 * content such as filters, forms, or controls positioned relative to the
 * calendar overlay.
 */
@ngCore.Component({
  imports: [
    ngMatDatepicker.MatDatepickerModule,
    form.Component,
    customRanges.Component,
    header.Component,
  ],
  selector: 'atn-ds-date-range-overlay-content',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link ngMatDatepicker.MatCalendar} */
  private readonly _calendar = ngCore.inject<ngMatDatepicker.MatCalendar<Date>>(
    ngMatDatepicker.MatCalendar,
  )

  constructor() {
    ngCore.effect(() => {
      const dateRange = this.store.editingDateRangeSg()

      this._calendar.selected = models.DateRange.generate({
        end: dateRange.end,
        start: dateRange.start,
      })
      // Ensure the calendar view is focused on the selected start date when a
      // new range is applied
      if (dateRange.start) {
        this._calendar.activeDate = dateRange.start
      } else {
        this._calendar.activeDate = new Date()
      }
    })
  }
}
